(function (global) {
    var noConflict = global.main;
    global.main = function (callback) {
        var args = Array.prototype.slice.call(arguments, 1);
        global.main = function (config) {
            global.main = noConflict;
            callback.apply(null, [config].concat(args))
        };
    };
})(window);
